import React from 'react';
import { FileText, Award, Shield } from 'lucide-react';
export function Insurance() {
  const cards = [{
    title: 'Insurance Claim Help',
    copy: 'Get help with the quote, claim details and scheduling process.',
    icon: <FileText className="w-6 h-6 text-brand-blue" data-id="element-499" data-mp="1g0dyge2dlzm2" />
  }, {
    title: 'OEM & OEE Glass Options',
    copy: 'Ask about available glass options based on your vehicle, insurance, preference and budget.',
    icon: <Award className="w-6 h-6 text-brand-blue" data-id="element-500" data-mp="ndb31uszy501" />
  }, {
    title: 'Lifetime Workmanship Warranty',
    copy: 'Professional installation backed by a warranty on vehicle glass workmanship.',
    icon: <Shield className="w-6 h-6 text-brand-blue" data-id="element-501" data-mp="xbqujyvxrga2" />
  }];
  return <section className="py-16 lg:py-24 bg-navy-900 text-white" data-id="element-502" data-mp="12a22u56l1iq6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-503" data-mp="28pchrei8j7sy">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-504" data-mp="28qw1jf33o0zh">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-505" data-mp="2dm2vhv6khrb7">
            Insurance Help, Quality Glass & Warranty Protection
          </h2>
          <p className="text-lg text-slate-300" data-id="element-506" data-mp="arb5nvawz7jl">
            Kosin's Glass provides free auto glass quotes and can help
            coordinate with most insurance companies. The team installs quality
            glass that meets or exceeds OEM standards and backs auto glass
            workmanship with a lifetime vehicle glass workmanship warranty.
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-12 -mt-6 px-5 py-4 rounded-lg bg-navy-800/60 border border-navy-700 text-center" data-id="element-507" data-mp="3sz0nrv6jir9m">
          <p className="text-slate-200 text-sm md:text-base" data-id="element-508" data-mp="3j6uumi4jy3su">
            Local drivers choose Kosin's Glass for insurance help, certified
            installation and a lifetime vehicle glass workmanship warranty.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-509" data-mp="3a54w6sc964lk">
          {cards.map((card, index) => <div key={index} className="bg-navy-800 rounded-lg p-8 border border-navy-700 scroll-fade-up" style={{
          animationDelay: `${index * 0.08}s`
        }} data-id="element-510" data-mp="357v6rcov5sxq" data-mpi={index}>
              <div className="w-12 h-12 bg-navy-900 rounded-lg flex items-center justify-center mb-6 border border-navy-700 shadow-inner" data-id="element-511" data-mp="2lll1agh0y754">
                {card.icon}
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-512" data-mp="2qmhb1ao24nig">{card.title}</h3>
              <p className="text-slate-300 leading-relaxed" data-id="element-513" data-mp="3eaqtq3pz4v5d">{card.copy}</p>
            </div>)}
        </div>
      </div>
    </section>;
}